const applicationsPagePath = '/applications';
const modelsPagePath = '/models';
const dataPagePath = '/data/:tabId';

export { applicationsPagePath, dataPagePath, modelsPagePath };
